import { useEffect } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import numeral from 'numeral';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import isArray from 'lodash/isArray';

dayjs.extend(localizedFormat);

export const splitFootballScore = text => {
  const textArr = text.split('-');
  const left = textArr[0].replaceAll(' ', '');
  const right = textArr[1].replaceAll(' ', '');
  return { left: left, right: right };
};

export function dropSomeField(obj, fieldArray) {
  const object = { ...obj };
  for (let index = 0; index < fieldArray.length; index++) {
    delete object[fieldArray[index]];
  }
  return object;
}

export const timestamp = () => {
  return dayjs(Date.now()).format('YYYY-MM-DD HH:mm:ss');
};
export const convertDatasets = (data, topic, isValue) => {
  const results = [];

  if (isValue) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].key.startsWith(topic)) {
        results.push(data[i].value);
      }
    }
  } else {
    for (let i = 0; i < data.length; i++) {
      if (data[i].topic.startsWith(topic)) {
        results.push(data[i].dataSet);
      }
    }
  }

  return isValue ? results[0] : results;
};
export const escapeChar = str => {
  if (!str) return null;
  return `${str}`.replace(/[\\]/g, '').replace(/["]/g, '\\$&');
};

export function rewriteCid(_txt) {
  switch (_txt) {
    case 'video':
      return '/category/video';
    case 'column':
      return '/category/column';
    default:
      return '/category/news';
  }
}
export function rewriteTxt(_txt) {
  if (_txt.indexOf('.') !== -1) return 'news';
  switch (_txt) {
    case 'category':
    case 'rss':
      return 'news';
    case 'column':
      return 'column';
    default:
      return _txt;
  }
}
export function rewriteSup(_txt) {
  if (_txt.indexOf('.') !== -1) {
    return '';
  } else {
    return _txt;
  }
}

export const escapeCharTitle = str => {
  if (!str) return null;
  return `${str}`.replace(/["]/g, '');
};

export const htmlEntities = str => {
  if (!str) return null;
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
};

export const convertObjPath = _obj => {
  if (!_obj || Object.keys(_obj).length < 1) return '';
  const entries = Object.entries(_obj);
  const itemData = encodeURI(`?${entries.join('&').split(',').join('=')}`);
  // const itemData = `?${entries[0].shift(0)}=${encodeURIComponent(entries.join('&').split(',').join('='))}`;
  // const itemData = `?${entries[0].shift(0)}=${encodeURI(entries.join('&').split(',').join('='))}`;
  return itemData;
};

export const convertObjPathNoneEncode = _obj => {
  if (!_obj || Object.keys(_obj).length < 1) return '';
  const entries = Object.entries(_obj);
  const itemData = `?${entries.join('&').split(',').join('=')}`;
  return itemData;
};

export function convertBadge(data, format) {
  if (format) return `${data?.section?.th}/${data?.subCategory?.th}`;
  return data?.subCategory?.th ? data?.subCategory?.th : data?.section?.th;
}

export const convertArrPath = (_obj, field) => {
  let result = '';
  if (!isArray(_obj)) return null;

  if (_obj?.length > 0) {
    result = `?${field}[]=${_obj.join(`&${field}[]=`)}`;
  } else {
    result = `?${field}=${_obj[0]}`;
  }
  return encodeURI(result);
};

// TODO : check children is empty
// ? (childrenEmpty('  ')) return true
// ? (childrenEmpty(null)) return false
// ? (childrenEmpty(123)) return false
// ? (childrenEmpty()) return false
export function childrenEmpty(_child) {
  return !`${_child}`.split(' ').join('');
}

// TODO Wait API
export function delay(_ms) {
  return new Promise(resolve => {
    setTimeout(resolve, _ms);
  });
}

// TODO : clean action in menu
export function useOnClickOutsideExpand(ref, handler) {
  useEffect(() => {
    const listener = event => {
      // if (!ref.current || ref?.current.contains(event.target)) {
      if (!ref.current) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mouseleave', listener);

    return () => {
      document.removeEventListener('mouseleave', listener);
    };
  }, [ref, handler]);
}

// TODO : actionSidebar
export function toggleSidebar(_toggle) {
  if (_toggle) {
    document.getElementById('__next').classList.remove('menu-inactive');
    document.getElementById('__next').classList.add('menu-active');
    document.getElementById('__next').classList.add('header-switch-hide');
    document.getElementById('menu-switch').classList.add('hidden');
  } else {
    document.getElementById('__next').classList.remove('menu-active');
    document.getElementById('__next').classList.add('menu-inactive');
    document.getElementById('menu-switch').classList.remove('hidden');
  }
}

/* ------------------------------- HOW TO USE ------------------------------- */
// TODO : Import to css globals and set id in component menu-mobile
// .menu-active {
//   height: 100vh;
//   position: fixed;
//   transform: translate3d(320px, 0, 0);
//   transition: all .4s ease;
// }
// .menu-inactive {
//  transform: translate3d(0, 0, 0);
// transition: all .4s ease;
// }

// TODO : DATE NOW
// dateNow();
export function useDateNow() {
  const now = dayjs(new Date());
  const christianYear = now.format('YYYY');
  const buddhishYear = (parseInt(christianYear) + 543).toString();
  const today = now.locale('th').format('LLLL').replace(christianYear, buddhishYear);
  return today;
}

// TODO : DATE UPDATE
// useDateUpdate()
export function useDateUpdate(_date, _showTime) {
  if (!_date) return null;
  const _format = _showTime === true ? 'DD MMM YYYY |  HH:mm น.' : 'DD MMM YYYY';
  return dayjs(_date).locale('th').add(543, 'year').format(_format);
}
// useTimeUpdate()
export function useTimeUpdate(_date) {
  if (!_date) return null;
  return dayjs(_date).locale('th').add(543, 'year').format('HH:mm');
}

// // TODO : RENDER PAGEVIEWS
// // usePageViews(data);
export function usePageViews(_pageviews) {
  const result = _pageviews > 999 ? numeral(+_pageviews).format('0.0 a') : _pageviews;
  // console.log({ result });
  return result;
}

// // TODO : SET  NUMERAL
// export function setNumeral (num) {
//   return numeral(num).format('0,0');
// }

// TODO : ModifyMenu
// ModifyMenu(menu);
// Check nameEng('Lottery')
export function ModifyMenu(_array) {
  if (!Array.isArray(_array) || !_array) return [];
  return (
    Array.isArray(_array) &&
    _array.reduce((acc, cur) => {
      const indexEl = _array.findIndex(el => el.nameEng.indexOf('lottery') && cur.nameEng.indexOf('lottery'));
      if (indexEl !== -1) {
        return [...acc, { ...cur }];
      } else {
        return [...acc, { ...cur, sub: [] }];
      }
    }, [])
  );
}

export function isExistAds(array, position) {
  return !isEmpty(find(array, { position: position }));
}

export function htmlToPlainText(html) {
  const parser = new DOMParser();
  const dom = parser.parseFromString(html, 'text/html');
  return dom.body.textContent || '';
}
